import './src/fonts/typography.css'

export { wrapRootElement, wrapPageElement } from './wrap-element'
